import { heroLead, heroCards } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section className="px-4 md:px-8 pt-8 md:pt-12 pb-10">
      <div className="flex items-end justify-between mb-6 animate-fade-up">
        <div>
          <p className="text-xs tracking-[0.3em] text-primary-600 font-label mb-2">VOL.91 · 本期导读</p>
          <h1 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
            今天，先看这几个
          </h1>
        </div>
        <a
          href="#collections"
          className="hidden md:inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 cursor-pointer"
        >
          查看全部推荐 <i className="ri-arrow-right-line" />
        </a>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        <a
          href="#videos"
          className="lg:col-span-6 group relative block rounded-lg overflow-hidden bg-background-100 animate-fade-up cursor-pointer"
        >
          <div className="relative w-full h-[300px] md:h-[440px] overflow-hidden">
            <img
              src={heroLead.image}
              alt="本期封面精选合集"
              title="91网 本期封面精选合集"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent" />
          </div>
          <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-accent-500 text-accent-950 text-xs font-medium">
            {heroLead.tag}
          </span>
          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
            <h2 className="font-heading text-xl md:text-3xl font-black text-white leading-snug">
              {heroLead.title}
            </h2>
            <p className="mt-2 text-sm text-white/85 max-w-xl line-clamp-2">{heroLead.desc}</p>
            <div className="mt-4 flex items-center gap-3 text-xs text-white/80">
              <span className="inline-flex items-center gap-1">
                <i className="ri-play-circle-fill text-base" /> {heroLead.meta}
              </span>
            </div>
          </div>
        </a>

        <div className="lg:col-span-6 grid grid-cols-2 gap-5">
          {heroCards.map((card) => (
            <a
              href="#videos"
              key={card.title}
              className="group relative block rounded-lg overflow-hidden bg-background-100 h-[180px] md:h-[210px] cursor-pointer"
            >
              <img
                src={card.image}
                alt={card.title}
                title={`${card.title} 91网推荐`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <span className="absolute top-3 right-3 w-8 h-8 rounded-full bg-background-50/90 flex items-center justify-center text-primary-600">
                <i className="ri-play-fill text-sm" />
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-3.5">
                <span className="inline-block px-2 py-0.5 rounded bg-white/15 text-white text-[11px]">
                  {card.tag}
                </span>
                <h3 className="mt-1.5 font-heading text-sm md:text-base font-bold text-white leading-snug line-clamp-2">
                  {card.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}